import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import "./pricing14.css";
import { useTranslation } from "react-i18next";
import ClientSetupForm from "./ClientSetupForm";
import AlertModal from "./AlertModal";
import { BACKEND_BASE_URL } from "../config/appUrls";

const PLAN_TYPES = {
  TYPICAL: "Typical",
  ENTREPRENEUR: "Entrepreneur",
  ELITE: "Elite"
};

const PAYMENT_OPTIONS = {
  MONTHLY: "Monthly",
  YEARLY: "Yearly"
};

const Pricing14 = ({
  plan3Price = undefined,
  plan3Action = undefined,
  plan11 = undefined,
  plan1Action = undefined,
  plan31 = undefined,
  plan3Feature41 = undefined,
  plan1Feature2 = undefined,
  plan2Feature11 = undefined,
  plan3Feature51 = undefined,
  plan2Feature41 = undefined,
  plan2Feature2 = undefined,
  plan3Feature21 = undefined,
  plan2Feature4 = undefined,
  plan2Yearly = undefined,
  plan1Action1 = undefined,
  plan2Action = undefined,
  plan3Feature1 = undefined,
  plan2Feature3 = undefined,
  plan1Price1 = undefined,
  plan2 = undefined,
  plan2Feature21 = undefined,
  plan2Action1 = undefined,
  plan3Feature2 = undefined,
  content1 = undefined,
  plan2Feature1 = undefined,
  heading1 = undefined,
  plan3Feature31 = undefined,
  plan1 = undefined,
  plan21 = undefined,
  plan1Feature11 = undefined,
  plan1Feature21 = undefined,
  plan3Feature5 = undefined,
  plan2Yearly1 = undefined,
  plan2Price = undefined,
  plan3Yearly1 = undefined,
  plan2Feature31 = undefined,
  plan3Feature11 = undefined,
  plan1Yearly1 = undefined,
  plan2Price1 = undefined,
  plan3Yearly = undefined,
  plan3Feature4 = undefined,
  plan3Price1 = undefined,
  plan1Feature31 = undefined,
  plan1Feature3 = undefined,
  plan1Yearly = undefined,
  plan1Feature1 = undefined,
  plan3Feature3 = undefined,
  content2 = undefined,
  plan3Action1 = undefined,
  plan1Price = undefined,
  plan3 = undefined
}) => {
  const { t } = useTranslation();
  const [isMonthly, setIsMonthly] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [createdClientId, setCreatedClientId] = useState(null);
  const [alertMsg, setAlertMsg] = useState("");

  const paymentOption = isMonthly
    ? PAYMENT_OPTIONS.MONTHLY
    : PAYMENT_OPTIONS.YEARLY;

  const handleActivationAfterForm = async (planType, paymentOption, clientId) => {
    try {
      const response = await fetch(`${BACKEND_BASE_URL}/api/create-activation-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ planType, paymentOption, clientId })
      });

      const data = await response.json();

      if (data.url) {
        window.location.href = data.url;
      } else {
        setAlertMsg(t("home.pricing.noCheckoutUrl", "No checkout URL returned"));
      }

    } catch (err) {
      console.error("❌ Activation error:", err);
    }
  };

  return (
    <div className="pricing14-pricing23 thq-section-padding">
      <div className="pricing14-max-width thq-section-max-width">
        <div className="pricing14-section-title">
          <span className="pricing14-text100 thq-body-small">
            {content1 ?? (
              <Fragment>
                <span className="pricing14-text178">
                  {t("home.pricing.content1")}
                </span>
              </Fragment>
            )}
          </span>
          <div className="pricing14-content">
            <h2 className="pricing14-text101 thq-heading-2">
              {heading1 ?? (
                <Fragment>
                  <span className="pricing14-text180">
                    {t("home.pricing.heading")}
                  </span>
                </Fragment>
              )}
            </h2>
            <p className="pricing14-text102 thq-body-large">
              {content2 ?? (
                <Fragment>
                  <span className="pricing14-text202">
                    {t("home.pricing.content2")}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: " "
                      }}
                    />
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="pricing14-tabs">
          {showForm && (
            <div className="modal-overlay">
              <div className="modal-container">
                <button
                  className="modal-close"
                  onClick={() => setShowForm(false)}
                >
                  ✕
                </button>
                <ClientSetupForm
                  mode="standalone"
                  onComplete={(result) => {
                    if (result?.status === "success") {
                      setCreatedClientId(result.client_id);
                    }
                  }}
                  onContinue={async () => {
                    await handleActivationAfterForm(
                      selectedPlan,
                      selectedPayment,
                      createdClientId
                    );
                  }}
                />
              </div>
            </div>
          )}
          {isMonthly === true && (
            <button
              onClick={() => setIsMonthly(true)}
              className="pricing14-button10 thq-button-animated thq-button-filled"
            >
              <span className="thq-body-small">
                {t("home.pricing.monthly")}
              </span>
            </button>
          )}
          {isMonthly === false && (
            <button
              onClick={() => setIsMonthly(true)}
              className="pricing14-button11 thq-button-outline thq-button-animated"
            >
              <span className="thq-body-small">
                {t("home.pricing.monthly")}
              </span>
            </button>
          )}
          {isMonthly === false && (
            <button
              onClick={() => setIsMonthly(false)}
              className="pricing14-button12 thq-button-animated thq-button-filled"
            >
              <span className="thq-body-small">{t("home.pricing.yearly")}</span>
            </button>
          )}
          {isMonthly === true && (
            <button
              onClick={() => setIsMonthly(false)}
              className="pricing14-button13 thq-button-outline thq-button-animated"
            >
              <span className="thq-body-small">{t("home.pricing.yearly")}</span>
            </button>
          )}
        </div>
        {isMonthly === true && (
          <div className="pricing14-container1">
            <div className="pricing14-column1 thq-card">
              <div className="pricing14-price10">
                <div className="pricing14-price11">
                  <p className="pricing14-text107 thq-body-large">
                    {plan1 ?? (
                      <Fragment>
                        <span className="pricing14-text182">
                          {t("home.pricing.plan1.title")}
                        </span>
                      </Fragment>
                    )}
                  </p>
                  <h3 className="pricing14-text108 thq-heading-3">
                    {plan1Price ?? (
                      <Fragment>
                        <span className="pricing14-text204">
                          {t("home.pricing.plan1.price1")}
                        </span>
                      </Fragment>
                    )}
                  </h3>
                  <p className="thq-body-large">
                    {plan1Yearly ?? (
                      <Fragment>
                        <span className="pricing14-text199">
                          {t("home.pricing.plan1.price11")}
                        </span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list1">
                  <div className="pricing14-list-item10">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan1Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text200">
                            {t("home.pricing.plan1.feature1")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item11">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan1Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text161">
                            {t("home.pricing.plan1.feature2")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item12">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan1Feature3 ?? (
                        <Fragment>
                          <span className="pricing14-text198">
                            {t("home.pricing.plan1.feature3")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button
                className="pricing14-button14 thq-button-outline thq-button-animate"
                onClick={() => {
                  setSelectedPlan(PLAN_TYPES.TYPICAL);
                  setSelectedPayment(paymentOption);
                  setShowForm(true);
                }
                }
              >
                <span className="thq-body-small">
                  {plan1Action ?? (
                    <Fragment>
                      <span className="pricing14-text158">
                        {t("home.pricing.plan1.action")}
                      </span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
            <div className="pricing14-column2 thq-card">
              <div className="pricing14-price12">
                <div className="pricing14-price13">
                  <p className="pricing14-text114 thq-body-large">
                    {plan2 ?? (
                      <Fragment>
                        <span className="pricing14-text174">
                          {t("home.pricing.plan2.title")}
                        </span>
                      </Fragment>
                    )}
                  </p>
                  <h3 className="pricing14-text115 thq-heading-3">
                    {plan2Price ?? (
                      <Fragment>
                        <span className="pricing14-text188">
                          {t("home.pricing.plan2.price2")}
                        </span>
                      </Fragment>
                    )}
                  </h3>
                  <p className="thq-body-large">
                    {plan2Yearly ?? (
                      <Fragment>
                        <span className="pricing14-text168">
                          {t("home.pricing.plan2.price22")}
                        </span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list2">
                  <div className="pricing14-list-item13">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text179">
                            {t("home.pricing.plan2.feature1")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item14">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text165">
                            {t("home.pricing.plan2.feature2")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item15">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature3 ?? (
                        <Fragment>
                          <span className="pricing14-text172">
                            {t("home.pricing.plan2.feature3")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item16">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature4 ?? (
                        <Fragment>
                          <span className="pricing14-text167">
                            {t("home.pricing.plan2.feature4")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button
                className="pricing14-button15 thq-button-animated thq-button-filled"
                onClick={() => {
                  setSelectedPlan(PLAN_TYPES.ENTREPRENEUR);
                  setSelectedPayment(paymentOption);
                  setShowForm(true);
                }
                }
              >
                <span className="thq-body-small">
                  {plan2Action ?? (
                    <Fragment>
                      <span className="pricing14-text170">
                        {t("home.pricing.plan2.action")}
                      </span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
            <div className="pricing14-column3 thq-card">
              <div className="pricing14-price14">
                <div className="pricing14-price15">
                  <p className="pricing14-text122 thq-body-large">
                    {plan3 ?? (
                      <Fragment>
                        <span className="pricing14-text205">
                          {t("home.pricing.plan3.title")}
                        </span>
                      </Fragment>
                    )}
                  </p>
                  <h3 className="pricing14-text123 thq-heading-3">
                    {plan3Price ?? (
                      <Fragment>
                        <span className="pricing14-text155">
                          {t("home.pricing.plan3.price3")}
                        </span>
                      </Fragment>
                    )}
                  </h3>
                  <p className="thq-body-large">
                    {plan3Yearly ?? (
                      <Fragment>
                        <span className="pricing14-text194">
                          {t("home.pricing.plan3.price33")}
                        </span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list3">
                  <div className="pricing14-list-item17">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text171">
                            {t("home.pricing.plan3.feature1")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item18">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text177">
                            {t("home.pricing.plan3.feature2")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item19">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature3 ?? (
                        <Fragment>
                          <span className="pricing14-text201">
                            {t("home.pricing.plan3.feature3")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item20">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature4 ?? (
                        <Fragment>
                          <span className="pricing14-text195">
                            {t("home.pricing.plan3.feature4")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item21">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature5 ?? (
                        <Fragment>
                          <span className="pricing14-text186">
                            {t("home.pricing.plan3.feature5")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button
                className="pricing14-button16 thq-button-animated thq-button-filled"
                onClick={() => {
                  setSelectedPlan(PLAN_TYPES.ELITE);
                  setSelectedPayment(paymentOption);
                  setShowForm(true);
                }
                }
              >
                <span className="thq-body-small">
                  {plan3Action ?? (
                    <Fragment>
                      <span className="pricing14-text156">
                        {t("home.pricing.plan3.action")}
                      </span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
          </div>
        )}
        {isMonthly === false && (
          <div className="pricing14-container2">
            <div className="pricing14-column4 thq-card">
              <div className="pricing14-price16">
                <div className="pricing14-price17">
                  <span className="pricing14-text131 thq-body-large">
                    {plan11 ?? (
                      <Fragment>
                        <span className="pricing14-text157">
                          {t("home.pricing.plan1.title")}
                        </span>
                      </Fragment>
                    )}
                  </span>
                  <h3 className="pricing14-text132 thq-heading-3">
                    {plan1Price1 ?? (
                      <Fragment>
                        <span className="pricing14-text173">
                          {t("home.pricing.plan1.yearly1")}
                        </span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-large">
                    {plan1Yearly1 ?? (
                      <Fragment>
                        <span className="pricing14-text192">
                          {t("home.pricing.plan1.yearly11")}
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing14-list4">
                  <div className="pricing14-list-item22">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan1Feature11 ?? (
                        <Fragment>
                          <span className="pricing14-text184">
                            {t("home.pricing.plan1.feature1")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item23">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan1Feature21 ?? (
                        <Fragment>
                          <span className="pricing14-text185">
                            {t("home.pricing.plan1.feature2")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item24">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan1Feature31 ?? (
                        <Fragment>
                          <span className="pricing14-text197">
                            {t("home.pricing.plan1.feature3")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button
                className="pricing14-button17 thq-button-outline thq-button-animated"
                onClick={() => {
                  setSelectedPlan(PLAN_TYPES.TYPICAL);
                  setSelectedPayment(paymentOption);
                  setShowForm(true);
                }
                }
              >
                <span className="thq-body-small">
                  {plan1Action1 ?? (
                    <Fragment>
                      <span className="pricing14-text169">
                        {t("home.pricing.plan1.action")}
                      </span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
            <div className="pricing14-column5 thq-card">
              <div className="pricing14-price18">
                <div className="pricing14-price19">
                  <span className="pricing14-text138 thq-body-large">
                    {plan21 ?? (
                      <Fragment>
                        <span className="pricing14-text183">
                          {t("home.pricing.plan2.title")}
                        </span>
                      </Fragment>
                    )}
                  </span>
                  <h3 className="pricing14-text139 thq-heading-3">
                    {plan2Price1 ?? (
                      <Fragment>
                        <span className="pricing14-text193">
                          {t("home.pricing.plan2.yearly2")}
                        </span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-large">
                    {plan2Yearly1 ?? (
                      <Fragment>
                        <span className="pricing14-text187">
                          {t("home.pricing.plan2.yearly22")}
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing14-list5">
                  <div className="pricing14-list-item25">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature11 ?? (
                        <Fragment>
                          <span className="pricing14-text162">
                            {t("home.pricing.plan2.feature1")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item26">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature21 ?? (
                        <Fragment>
                          <span className="pricing14-text175">
                            {t("home.pricing.plan2.feature2")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item27">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature31 ?? (
                        <Fragment>
                          <span className="pricing14-text190">
                            {t("home.pricing.plan2.feature3")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item28">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan2Feature41 ?? (
                        <Fragment>
                          <span className="pricing14-text164">
                            {t("home.pricing.plan2.feature4")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button
                className="pricing14-button18 thq-button-animated thq-button-filled"
                onClick={() => {
                  setSelectedPlan(PLAN_TYPES.ENTREPRENEUR);
                  setSelectedPayment(paymentOption);
                  setShowForm(true);
                }
                }
              >
                <span className="thq-body-small">
                  {plan2Action1 ?? (
                    <Fragment>
                      <span className="pricing14-text176">
                        {t("home.pricing.plan2.action")}
                      </span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
            <div className="pricing14-column6 thq-card">
              <div className="pricing14-price20">
                <div className="pricing14-price21">
                  <span className="pricing14-text146 thq-body-large">
                    {plan31 ?? (
                      <Fragment>
                        <span className="pricing14-text159">
                          {t("home.pricing.plan3.title")}
                        </span>
                      </Fragment>
                    )}
                  </span>
                  <h3 className="pricing14-text147 thq-heading-3">
                    {plan3Price1 ?? (
                      <Fragment>
                        <span className="pricing14-text196">
                          {t("home.pricing.plan3.yearly3")}
                        </span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-large">
                    {plan3Yearly1 ?? (
                      <Fragment>
                        <span className="pricing14-text189">
                          {t("home.pricing.plan3.yearly33")}
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing14-list6">
                  <div className="pricing14-list-item29">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature11 ?? (
                        <Fragment>
                          <span className="pricing14-text191">
                            {t("home.pricing.plan3.feature1")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item30">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature21 ?? (
                        <Fragment>
                          <span className="pricing14-text166">
                            {t("home.pricing.plan3.feature2")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item31">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature31 ?? (
                        <Fragment>
                          <span className="pricing14-text181">
                            {t("home.pricing.plan3.feature3")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item32">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature41 ?? (
                        <Fragment>
                          <span className="pricing14-text160">
                            {t("home.pricing.plan3.feature4")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item33">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {plan3Feature51 ?? (
                        <Fragment>
                          <span className="pricing14-text163">
                            {t("home.pricing.plan3.feature5")}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button
                className="pricing14-button19 thq-button-animated thq-button-filled"
                onClick={() => {
                  setSelectedPlan(PLAN_TYPES.ELITE);
                  setSelectedPayment(paymentOption);
                  setShowForm(true);
                }
                }
              >
                <span className="thq-body-small">
                  {plan3Action1 ?? (
                    <Fragment>
                      <span className="pricing14-text203">
                        {t("home.pricing.plan3.action")}
                      </span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
      <AlertModal
        open={Boolean(alertMsg)}
        message={alertMsg}
        onClose={() => setAlertMsg("")}
      />
    </div>
  );
};

Pricing14.propTypes = {
  plan3Price: PropTypes.element,
  plan3Action: PropTypes.element,
  plan11: PropTypes.element,
  plan1Action: PropTypes.element,
  plan31: PropTypes.element,
  plan3Feature41: PropTypes.element,
  plan1Feature2: PropTypes.element,
  plan2Feature11: PropTypes.element,
  plan3Feature51: PropTypes.element,
  plan2Feature41: PropTypes.element,
  plan2Feature2: PropTypes.element,
  plan3Feature21: PropTypes.element,
  plan2Feature4: PropTypes.element,
  plan2Yearly: PropTypes.element,
  plan1Action1: PropTypes.element,
  plan2Action: PropTypes.element,
  plan3Feature1: PropTypes.element,
  plan2Feature3: PropTypes.element,
  plan1Price1: PropTypes.element,
  plan2: PropTypes.element,
  plan2Feature21: PropTypes.element,
  plan2Action1: PropTypes.element,
  plan3Feature2: PropTypes.element,
  content1: PropTypes.element,
  plan2Feature1: PropTypes.element,
  heading1: PropTypes.element,
  plan3Feature31: PropTypes.element,
  plan1: PropTypes.element,
  plan21: PropTypes.element,
  plan1Feature11: PropTypes.element,
  plan1Feature21: PropTypes.element,
  plan3Feature5: PropTypes.element,
  plan2Yearly1: PropTypes.element,
  plan2Price: PropTypes.element,
  plan3Yearly1: PropTypes.element,
  plan2Feature31: PropTypes.element,
  plan3Feature11: PropTypes.element,
  plan1Yearly1: PropTypes.element,
  plan2Price1: PropTypes.element,
  plan3Yearly: PropTypes.element,
  plan3Feature4: PropTypes.element,
  plan3Price1: PropTypes.element,
  plan1Feature31: PropTypes.element,
  plan1Feature3: PropTypes.element,
  plan1Yearly: PropTypes.element,
  plan1Feature1: PropTypes.element,
  plan3Feature3: PropTypes.element,
  content2: PropTypes.element,
  plan3Action1: PropTypes.element,
  plan1Price: PropTypes.element,
  plan3: PropTypes.element
};

export default Pricing14;
